import {
  NavbarFloating,
  NavbarBackLink,
  NavbarButton,
  NavbarContainer,
  NavbarCtaContainer,
  NavbarLink,
  NavbarLinksGroup,
  NavbarMenu,
} from './components';

// ─────────────────────────────────────────────────────────────────────────────

export const Navbar = {
  Floating: NavbarFloating,
  Container: NavbarContainer,
  LinksGroup: NavbarLinksGroup,
  Link: NavbarLink,
  BackLink: NavbarBackLink,
  Button: NavbarButton,
  CtaContainer: NavbarCtaContainer,
  Menu: NavbarMenu,
};
